export default "__VITE_ASSET__4nDx8Nwg__"